export const ProfilePaths = {
  ROOT: '/profile',
} as const;
